export const APPROVED_DASHBOARD_TIPS = Object.freeze([
  {
    id: "portion-review",
    title: "Review portions before eating",
    title_ar: "راجع الحصص قبل الأكل",
    body: "Check the serving size before adding a food so your daily totals stay accurate.",
    body_ar: "تحقق من حجم الحصة قبل إضافة الطعام حتى تبقى إجمالياتك اليومية دقيقة.",
    category: "Food tracking",
    category_ar: "تتبع الطعام",
  },
  {
    id: "custom-foods",
    title: "Use custom foods for home meals",
    title_ar: "استخدم الأطعمة المخصصة للوجبات المنزلية",
    body: "Add local or homemade meals with measured nutrient values when they are not in the food list.",
    body_ar: "أضف الوجبات المحلية أو المنزلية بقيم عناصر مقاسة عندما لا تكون موجودة في قائمة الطعام.",
    category: "Custom foods",
    category_ar: "أطعمة مخصصة",
  },
  {
    id: "daily-limits",
    title: "Keep limits current",
    title_ar: "حافظ على تحديث الحدود",
    body: "Update your daily limits in settings when your care team changes your plan.",
    body_ar: "حدّث حدودك اليومية في الإعدادات عندما يغيّر فريق الرعاية خطتك.",
    category: "Settings",
    category_ar: "الإعدادات",
  },
]);

export const DASHBOARD_QUOTES = Object.freeze([
  {
    id: "steady-progress",
    quote: "Small accurate choices build steady progress.",
    quote_ar: "الاختيارات الصغيرة والدقيقة تبني تقدمًا ثابتًا.",
  },
  {
    id: "clear-day",
    quote: "Track clearly, decide calmly, move forward.",
    quote_ar: "تتبّع بوضوح، قرر بهدوء، وتقدم للأمام.",
  },
  {
    id: "one-day",
    quote: "One well-tracked day is a strong step.",
    quote_ar: "يوم واحد متتبع جيدًا هو خطوة قوية.",
  },
]);

export function getQuoteOfTheDay(date = new Date()) {
  const dayNumber = Math.floor(date.getTime() / 86400000);
  return DASHBOARD_QUOTES[Math.abs(dayNumber) % DASHBOARD_QUOTES.length];
}
